import { render, staticRenderFns } from "./CommissionsTable.vue?vue&type=template&id=d623b512&scoped=true"
import script from "./CommissionsTable.vue?vue&type=script&lang=ts"
export * from "./CommissionsTable.vue?vue&type=script&lang=ts"
import style0 from "./CommissionsTable.vue?vue&type=style&index=0&id=d623b512&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d623b512",
  null
  
)

export default component.exports